/** 接口不可用时的默认比例：100 DSCoin = 1 USDC */
export const DEFAULT_POINTS_PER_USDC = 100;

/**
 * 解析 GET /wallet/convert/points-to-usdc/rate 返回值
 * @param {unknown} raw
 * @returns {number|null}
 */
export function parsePointsToUsdcRate(raw) {
  const num = Number(raw);
  if (!Number.isFinite(num) || num <= 0) return null;
  return num;
}

/** 展示用：每 1 USDC 所需积分数量 */
export function resolvePointsPerUsdc(rate) {
  const r = parsePointsToUsdcRate(rate);
  if (r == null) return DEFAULT_POINTS_PER_USDC;
  return r >= 1 ? r : 1 / r;
}

/** 按接口比例计算可兑换 USDC 数量 */
export function calcUsdcFromPoints(points, rate) {
  const amount = Number(points);
  if (!Number.isFinite(amount) || amount <= 0) return 0;

  const r = parsePointsToUsdcRate(rate);
  if (r == null) return amount / DEFAULT_POINTS_PER_USDC;
  return r >= 1 ? amount / r : amount * r;
}

/**
 * DSCoin → 约合美元文案：保留 2 位、向 0 截断（不四舍五入）
 * @param {unknown} points
 * @param {unknown} [rate] 接口原始比例；缺省用 DEFAULT_POINTS_PER_USDC
 */
export function formatUsdcApproxTruncated(points, rate) {
  const num = Number(points);
  if (!Number.isFinite(num)) return '—';
  const pointsPerUsdc = resolvePointsPerUsdc(rate);
  if (!Number.isFinite(pointsPerUsdc) || pointsPerUsdc <= 0) return '—';

  const sign = num < 0 ? '-' : '';
  const absWhole = Math.abs(Math.trunc(num));
  // trunc2(abs / rate) ≡ floor(abs * 100 / rate) 分
  const totalCents = Math.floor((absWhole * 100) / pointsPerUsdc);
  const dollars = Math.floor(totalCents / 100);
  const cents = totalCents % 100;
  return `${sign}${dollars.toLocaleString('en-US')}.${String(cents).padStart(2, '0')}`;
}

/** 比例文案中的积分数（去掉多余小数） */
export function formatPointsPerUsdcLabel(value) {
  const num = Number(value);
  if (!Number.isFinite(num) || num <= 0) return String(DEFAULT_POINTS_PER_USDC);
  if (Number.isInteger(num)) return String(num);
  return num.toLocaleString('en-US', { maximumFractionDigits: 4 });
}
